import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import TourPicture from 'views/anyguide/bookings/tour_picture';
import customTourDefaultImage from 'views/anyguide/bookings/tour_picture/custom_tour_default.jpg';
import { findDOMNode } from 'react-dom';
import $ from 'jquery';

const TourCover = styled.div`
  display: ${(props) => (props.hideOnDesktop ? 'none' : 'block')};
  @media (max-width: 767px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'block')};
  }
`;

export default class CheckoutSummaryPicture extends React.Component {
  static displayName = 'CheckoutSummaryPicture';

  static propTypes = {
    tour_picture: PropTypes.string,
    rounded: PropTypes.bool,
    hideOnMobile: PropTypes.bool,
  };

  static defaultProps = {
    rounded: false,
  };

  componentDidMount() {
    // scroll this step to top on mobile views
    window.scrollTo(0, 0);
    if (this.props.rounded) {
      $(findDOMNode(this.refs.imageContainer)).imagefill();
    }
  }

  renderRoundedImage() {
    return (
      <div ref="imageContainer" className="CoverRounded">
        <img src={this.props.tour_picture} className="loading" />
      </div>
    );
  }

  renderBackgroundImage() {
    const picUrl = this.props.tour_picture || customTourDefaultImage;
    return (
      <div
        className="MobileCheckout-CoverPhoto"
        style={{ backgroundImage: `url('${picUrl}')` }}
      />
    );
  }

  renderImage() {
    return (
      <TourPicture defaultFor="tour" pictureUrl={this.props.tour_picture} />
    );
  }

  render() {
    const { hideOnMobile, hideOnDesktop } = this.props;
    return (
      <TourCover
        hideOnMobile={hideOnMobile}
        hideOnDesktop={hideOnDesktop}
        className="TourCover"
      >
        {this.props.rounded
          ? this.renderRoundedImage()
          : [this.renderImage(), this.renderBackgroundImage()]}
      </TourCover>
    );
  }
}
